import React from 'react';

import { SectionTitle } from '~common/ui/SectionTitle';
import { FAQItem } from '~features/faq/index';

export function DiamondHandsFAQ() {
  return (
    <div id="faq">
      <SectionTitle className="mb-6">FAQ - Diamond Hands</SectionTitle>

      <FAQItem question="#1 How do I keep my unvested tokens and future distributions in the projects I have previously participated in?">
        You need to stake at least the same as the initial tier you used to do
        the purchase in the sale.
        <br />
        <br />
        For instance, if an investor participated in a sale with the Executive
        tier, they need to stake at least at the Executive level in any of the
        IDO pools (7–1095 days or LP).
        <br />
        <br />
        The TPAD needs to be staked for the entirety of the vesting schedules of
        the tokens in order to receive them. If there is a period in which the
        tier is unstaked or unlocked continuously for 72 hours, then all the
        future vestings will be relinquished. There will be randomly timed
        snapshots that will be taken every 12 hours and if a wallet misses 6
        snapshots in a row, the unvested tokens will be lost. We will add a
        renew button to make sure you won’t ever miss the deadline. We will also
        offer a change pool button, by which you can change your staking to
        continue in a shorter period one after your current staking period ends.
        <br />
        <br />
        The forfeited tokens will be re-distributed to the Loyalists.
        <br />
        <br />
        Many of the investors who left and sold their TPAD, sold it for a way
        higher price and therefore they can repurchase and re-stake for a much
        lower amount of funds.
      </FAQItem>
      <FAQItem question="#2 How do I get the Diamond Hands retroactive rewards?">
        Retroactive rewards are the tokens of the following sales – SIDUS, BLOK,
        BLOKPAD, MV - which get distributed only to those stakers who staked
        before Feb 28, 23:59 UTC and kept staking until the moment of
        distribution.
        <br />
        <br />
        <ol>
          To be eligible to receive a portion of 75% of the rewards (DH75), the
          followings requirements need to be met:
          <br />
          <br />
          <li>
            1) You took part in the specific sale the distribution is about.
          </li>
          <li>
            2) You stake at least the same initial tier or at least a guaranteed
            tier if the initial tier was a lottery tier when you made the
            purchase for the sale.
          </li>
          <li>
            3) You staked the tier in the 1095 days pool before Feb 28, 23:59
            UTC at the latest.
          </li>
        </ol>
        The rest, 25% of the rewards (DH25) will be redistributed to all the AAG
        members of the 1095d pools without any other requirements than staking
        Feb 28, 23:59 UTC at the latest.
      </FAQItem>

      <FAQItem question="#3 What is the initial tier?">
        If your tier was Associate with 30 000 TPAD in a sale, you have to stake
        for 30 000 TPAD for that particular sale.
      </FAQItem>
      <FAQItem question="#4 Will the relinquished tokens be distributed based on tier or proportional TPAD holding?">
        The DH75 will be rewarded according to the initial bought amount. So, if
        an investor bought for 1000 BUSD in a 100 000 BUSD raise, they will get
        1k / 100k = 0.01 = 1% of the relinquished tokens if they are eligible.
        <br />
        <br />
        The DH20 will be rewarded proportionally by combining all the active AAG
        investor stakings in the +365 pools and distributing the tokens to the
        active members according to their share of this combined AAG pool. So,
        the more TPAD you just compound and buy, the more DH20 rewards you will
        receive, so claiming will result in diminished rewards.
      </FAQItem>
      <FAQItem question="#5 What must I do to receive the relinquished tokens, Diamond Hands rewards?">
        Keep your staking active in a 1095 days pool. For the DH75, you need to
        participate in a sale and stake at least the same tier you had during
        the sale. For the DH25, you need to stake at least an AAG tier in a 1095
        days pool.
      </FAQItem>
      <FAQItem question="#6 What are the criteria for new users to receive the DH rewards?">
        They can get the DH75 and DH25 rewards for all the new future projects.
        Retroactive rewards are only for those who staked before Feb 28, 23:59
        UTC.
      </FAQItem>
      <FAQItem question="#7 What if I changed my wallets?">
        There will be a solution for that, so you won’t lose your tokens, nor
        lose the Diamond Hands rewards for that. Just make sure your current
        wallet is eligible to retain the tokens and you are staking validly for
        the rewards.
      </FAQItem>
      <FAQItem question="#8 What if there is a refund?">
        If a sale is refunded, it will be refunded to those who are eligible to
        get their vestings. All the excess funds will be re-distributed as they
        are DH75 and DH25 rewards. You are supposed to keep your TPAD as staked
        for the entirety of the vesting schedule.
      </FAQItem>
    </div>
  );
}
